export default __webpack_public_path__ + "static/media/shariah_bg.acbdfcbe.png";